import { useMantineTheme } from "@mantine/core";
import { TieredPriceProductId } from "@project/common";

export function useStackedChartColors(): Record<TieredPriceProductId, string> {
  const { colors } = useMantineTheme();

  return {
    [TieredPriceProductId.TieredInputToken]: colors.error[3],
    [TieredPriceProductId.TieredOutputToken]: colors.warning[3],
    [TieredPriceProductId.TieredProcessing]: colors.info[5],
    [TieredPriceProductId.TieredMapSession]: colors.orange[8],
    [TieredPriceProductId.TieredTileUsage]: colors.purpleBlue[2],
    [TieredPriceProductId.TieredStorage]: colors.pink[1],
    [TieredPriceProductId.TieredCustomStyle]: colors.success[2],
    [TieredPriceProductId.TieredCustomTileset]: colors.info[2],
    [TieredPriceProductId.TieredAccountUser]: colors.orange[4],
  };
}
